import { useState } from 'react';
import { FaHeart } from 'react-icons/fa';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { 
    useAddFavoriteProductMutation,
    useDeleteFavoriteProductMutation, 
    useAddFavoriteShopMutation,
    useDeleteFavoriteShopMutation
} from '../slices/favoritesApiSlice';

const FavoriteButton = ({ itemId, isProduct }) => {
    const [isFavorite, setIsFavorite] = useState(false);
    const [isHovered, setIsHovered] = useState(false); // ← hover 管理
    const { userInfo } = useSelector((state) => state.auth);

    const [addFavoriteProduct] = useAddFavoriteProductMutation();
    const [deleteFavoriteProduct] = useDeleteFavoriteProductMutation();
    const [addFavoriteShop] = useAddFavoriteShopMutation();
    const [deleteFavoriteShop] = useDeleteFavoriteShopMutation();

    const handleFavoriteToggle = async () => {
        if (!userInfo) {
            toast.error('ログインが必要です');
            return;
        }

        try {
            if (isFavorite) {
                if (isProduct) {
                    await deleteFavoriteProduct(itemId).unwrap();
                } else {
                    await deleteFavoriteShop(itemId).unwrap();
                }
                toast.error('お気に入りから削除しました');
                setIsFavorite(false);
            } else {
                if (isProduct) {
                    const res = await addFavoriteProduct(itemId).unwrap();
                    if (res.alreadyFavorite) {
                        toast.info('すでにお気に入りに登録されています');
                        setIsFavorite(true);
                    } else {
                        toast.success('お気に入りに追加しました');
                        setIsFavorite(true);
                    }
                } else {
                    const res = await addFavoriteShop(itemId).unwrap();
                    if (res.alreadyFavorite) {
                        toast.info('すでにお気に入りに追加されています');
                        setIsFavorite(true);
                    } else {
                        toast.success('お気に入りに追加しました');
                        setIsFavorite(true);
                    }
                }
            }
        } catch (error) {
            toast.error('操作に失敗しました');
        }
    };

    return (
        <button
            className="favorite-button"
            onClick={handleFavoriteToggle}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            style={{
                cursor: 'pointer',
                background: 'transparent',
                border: 'none',
                outline: 'none',
                padding: 0,
                transition: 'transform 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
                transform: isHovered ? 'scale(1.2)' : 'scale(1)',
            }}
        >
            <FaHeart
                style={{
                    transition: 'color 0.2s ease',
                }}
                color={
                    isFavorite
                        ? '#ff4757'             // すでにお気に入り（鮮やかな赤）
                        : isHovered
                        ? '#ff6b9d'             // hover中（ピンク）
                        : '#d1d1d1'             // 通常状態
                }
            />
        </button>
    );
};

export default FavoriteButton;
